export default function CurrentConditionsSkeleton() {
  return (
    <section aria-busy="true" aria-label="Loading forecast" className="flex flex-col gap-3">
      <div className="rounded-xl bg-surface-container p-5">
        <p className="text-[18px] font-medium text-on-surface">Fetching latest forecast...</p>
        <p className="mt-2 text-[14px] text-on-surface-variant">
          Connecting to the tatterCast API and normalizing NWS forecast periods.
        </p>
      </div>
    </section>
  );
}
